var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"login",attrs:{"app":""}},[_c('v-container',{attrs:{"id":"app","app":""}},[_c('v-row',[_c('v-col',[_c('h1',{staticClass:"heading"},[_vm._v(" Redirecting to Login ... ")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }